import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useRecoilValue } from "recoil";
import CheckBoxLabelHookForm from "components/CheckBoxLabelHookForm";
import TextInputLabelHookForm from "components/TextInputLabelHookForm";
import { editStateFeeLevel } from "../atoms/atoms";
import { FeeLevelType } from "../../types";

const FeeLevelInput = (props: {
  setChanges: React.Dispatch<React.SetStateAction<boolean>>;
  data: FeeLevelType | undefined;
}) => {
  // Props drilled
  const { data, setChanges } = props;

  // Recoil Hook
  const edit = useRecoilValue(editStateFeeLevel);

  // Form Functions
  const { register } = useFormContext();
  const formMethods = useFormContext();

  // Local Hooks
  const [inputData, setInputData] = useState(data?.feeLevelName);
  const [checkBoxChanges, setCheckBoxChanges] = useState(data?.isActive);

  return (
    <>
      <div className="bg-bgDB">
        <div className="m-2 bg-white box-shadow h-full">
          <div className="grid grid-cols-4 mx-3 pb-2 gap-6 py-2">
            <div className="col-span-2 my-1">
              <TextInputLabelHookForm
                name="feeLevelName"
                label="Fee level Name"
                type="text"
                required={true}
                onChange={(e) => {
                  const value = e.target.value.trim();
                  setInputData(value);
                  if (
                    value.length === 0 ||
                    (value === data?.feeLevelName &&
                      checkBoxChanges === data?.isActive)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                }}
                className={
                  formMethods.formState.errors.feeLevelName &&
                  formMethods.formState.errors.feeLevelName.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("feeLevelName", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>

            {edit && (
              <div className="col-span-2 my-1">
                <CheckBoxLabelHookForm
                  name="isActive"
                  type="checkbox"
                  label={
                    checkBoxChanges
                      ? "Uncheck to Deactivate"
                      : "Check to Activate"
                  }
                  validation={{
                    required: {
                      value: false,
                      message: "Required Field",
                    },
                  }}
                  className={
                    formMethods.formState.errors.isActive &&
                    formMethods.formState.errors.isActive.message &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  onClick={(e) => {
                    setCheckBoxChanges(e.target.checked);
                    if (
                      inputData?.length === 0 ||
                      (e.target.checked === data?.isActive &&
                        inputData === data?.feeLevelName)
                    ) {
                      setChanges(false);
                    } else {
                      setChanges(true);
                    }
                  }}
                  register={register}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default FeeLevelInput;
